interface OrganizationFeatureSettings {
  purchasing_manager?: {
    enabled?: boolean;
  };
}

export function isPurchasingManagerEnabled(
  settings: unknown,
  role?: string | null
) {
  if (role === 'superadmin') return true;
  if (!settings || typeof settings !== 'object') return false;

  return Boolean(
    (settings as OrganizationFeatureSettings).purchasing_manager?.enabled
  );
}
